import request from '@/utils/request';
/**
 * 获取科室列表
 * @param {*} data 
 * @returns 
 */
export function getDeptList() {
    return request({
        url: '/pa/xcx/paxcxpro/admin/dept/list',
        method: 'get'
    })
}
/**
 * 获取全部科室
 * @returns 
 */
export function getAllDept() {
    return request({
        url: '/pa/xcx/paxcxpro/admin/dept/getAllDept',
        method: 'get'
    })
}
/**
 * 根据登录名(工号)获取科室列表
 * @param {*} userName 
 * @returns 
 */
export function getDeptById(userName) {
    return request({
        url: '/pa/xcx/paxcxpro/admin/employee/getUserLoc/' +userName,
        headers: {
            isToken: false
        },
        method: 'get'
    })
}
/**
 * 设置当前科室
 * @param {*} deptId 
 * @returns 
 */
export function setDeptId(deptId) {
    return request({
        url: '/pa/xcx/paxcxpro/admin/employee/set-current-dept/'+deptId,
        method: 'get'
    })
}
/**
 * 获取当前登录科室
 * @returns 
 */
export function getCurrentDept() {
    return request({
        url: '/pa/xcx/paxcxpro/admin/employee/get-current-dept',
        method: 'get'
    })
}